import React, { Component } from 'react'
import { Table, Popconfirm, Button, Spin, Modal, message, Divider } from 'antd'
import styled from "styled-components"
import OperatorForm from '@/components/Operator/OperatorForm'
import OperatorAPI from '@/API/operator'
import DeviceAPI from '@/API/device'
import { withTranslation } from 'react-i18next';

const ButtonContainer=styled.div`
  text-align:right;
`
const AddButton=styled(Button)`
  margin:20px 20px;
`
const OperatorTable=styled(Table)`
  margin:0 20px;
  td{
    word-break: break-all;
  }
`

class Operator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      operatorList:[],
      productList:[],
      loading:false,
      modalType:'add',
      modalShow:false,
      confirmLoading:false,
      formOperator:{
        operator:'',
        productNameListView:[],
        arrearsNotifyTitle:'',
        arrearsNotifyContent:'',
        upcomingLockNotifyTitle:'',
        upcomingLockNotifyContent:'',
        unbindNotifyTitle:'',
        unbindNotifyContent:'',
        restartNotifyTitle:'',
        restartNotifyContent:'',
        lockTitle:'',
        lockContent:'',
      },
      pagination:{
        current:1,
        pageSize:10,
        total:0,
        showSizeChanger:true,
        size:'small',
        showTotal:(total)=>(this.props.t('Total items',{total:total}))
      }
    }
    this.columns=[
      {
        title:this.props.t('Carrier Code'),
        width:170,
        dataIndex:'operator',
        key:'operator'
      },
      {
        title:this.props.t('Product List'),
        width:180,
        dataIndex:'productNameListView',
        key:'productNameListView',
        render:(text)=>(
          <span>{text&&text.join(',')}</span>
        )
      },
      {
        title:this.props.t('Payment Notification'),
        width:280,
        dataIndex:'arrearsNotifyContent',
        key:'arrearsNotifyContent',
        render:(text,record)=>(
          <span>{record.arrearsNotifyTitle}:<br></br>{text}</span>
        )
      },
      {
        title:this.props.t('Notification Before Locking Phone'),
        width:280,
        dataIndex:'upcomingLockNotifyContent',
        key:'upcomingLockNotifyContent',
        render:(text,record)=>(
          <span>{record.upcomingLockNotifyTitle}:<br></br>{text}</span>
        )
      },
      {
        title:this.props.t('Unbind Contract'),
        width:280,
        dataIndex:'unbindNotifyContent',
        key:'unbindNotifyContent',
        render:(text,record)=>(
          <span>{record.unbindNotifyTitle}:<br></br>{text}</span>
        )
      },
      {
        title:this.props.t('Restart Pop-Up Window'),
        width:280,
        dataIndex:'restartNotifyContent',
        key:'restartNotifyContent',
        render:(text,record)=>(
          <span>{record.restartNotifyTitle}:<br></br>{text}</span>
        )
      },
      {
        title:this.props.t('On Lock Screen Message'),
        width:280,
        dataIndex:'lockContent',
        key:'lockContent',
        render:(text,record)=>(
          <span>{record.lockTitle}:<br></br>{text}</span>
        )
      },
      {
        title:this.props.t('Operation'),
        key:'actions',
        width:250,
        align:'center',
        render:(text,record)=>(
          <span>
            <a onClick={()=>this.initEdit(record)}>{this.props.t('Edit')}</a>
            <Divider type="vertical"></Divider>
            <Popconfirm title={this.props.t('Delete the carrier?')} okType="danger" onConfirm={()=>this.deleteOperator(record)}>
              <a>{this.props.t('Delete')}</a>
            </Popconfirm>
          </span>
        )
      }
    ]
  }
  componentDidMount() {
    this.getOperatorList()
    this.getProductList()
  }
  getOperatorList=()=>{
    this.setState({loading:true})
    let pagination=this.state.pagination
    OperatorAPI.getOperatorList({pageIndex:pagination.current-1,pageSize:pagination.pageSize}).then((res)=>{
      console.log(res)
      this.setState((state)=>{
        return {operatorList:res.operators,pagination:{...state.pagination,total:res.totalCount}}
      })
      this.setState({loading:false})
    })
  }
  getProductList(){
    DeviceAPI.getAllProductList().then((res)=>{
      this.setState({productList:res||[]})
    })
  }
  handleFormChange = (changedFields) => {
    this.setState(({ formOperator }) => {
      return {
        formOperator: { ...formOperator, ...changedFields }
      }
    })
  }
  handleTableChange=(pagination)=>{
    this.setState({
      pagination: pagination,
    },()=>{
      this.getOperatorList()
    });
  }
  initAdd=()=>{
    this.setState({
      modalType:'add',
      modalShow:true,
      formOperator:{
        operator:'',
        productNameListView:[],
        arrearsNotifyTitle:'',
        arrearsNotifyContent:'',
        upcomingLockNotifyTitle:'',
        upcomingLockNotifyContent:'',
        unbindNotifyTitle:'',
        unbindNotifyContent:'',
        restartNotifyTitle:'',
        restartNotifyContent:'',
        lockTitle:'',
        lockContent:'',
      }
    })
  }
  initEdit=(record)=>{
    console.log(record)
    this.setState({
      modalType:'edit',
      modalShow:true,
      formOperator:record
    })
  }
  hideModal(){
    this.setState({modalShow:false})
  }
  //增加运营商发起请求
  addOrEditOperator=(operator)=>{
    this.setState({confirmLoading:true})
    OperatorAPI.addOrEditOperator(operator).then((res)=>{
      if(!res.code){
        this.hideModal()
        message.success(this.props.t('Added successfully.'))
        this.getOperatorList()
      }
      this.setState({confirmLoading:false})
    }).catch(()=>{
      this.setState({confirmLoading:false})
    })
  }
  deleteOperator=(operator)=>{
    OperatorAPI.deleteOperator({operator:operator.operator}).then((res)=>{
      if(!res.code){
        message.success(this.props.t('Deleted successfully.'))
        this.getOperatorList()
      }
    })
  }
  //点击按钮增加运营商
  handleOk=()=>{  
    const form=this.formRef.props.form
    form.validateFields((err,values)=>{
      if(err){
        return
      }
      let operator={...this.state.formOperator,productNameList:values.productNameListView,...values}
      delete operator.productNameListView
      //請求接口
      this.addOrEditOperator(operator)
    })
  }
  handleCancel=()=>{
    this.hideModal()
  }
  saveFormRef=(formRef)=>{
    this.formRef=formRef
  }
  render() {   
    const {pagination,operatorList,productList,loading,modalShow,modalType,confirmLoading,formOperator}=this.state
    const { t } = this.props;
    return (
      <div>
        <ButtonContainer>
          <AddButton type="primary" onClick={this.initAdd}>{t('Add Carrier')}</AddButton>
        </ButtonContainer>
        <Spin spinning={loading}>
          <OperatorTable   dataSource={operatorList} columns={this.columns} pagination={pagination} rowKey="operator" onChange={this.handleTableChange}></OperatorTable>
        </Spin>
        {
          modalShow&&(
            <Modal maskClosable={false} title={modalType==='add'?t('Add Carrier'):t('Edit Carrier')} visible={modalShow} onOk={this.handleOk} confirmLoading={confirmLoading} onCancel={this.handleCancel}>
              <OperatorForm wrappedComponentRef={this.saveFormRef} operator={formOperator} productList={productList} onChange={this.handleFormChange}></OperatorForm>
            </Modal>
          )
        }
      </div>
    )
    
  }
  
}
export default withTranslation()(Operator);